import { useNavigate } from "react-router-dom"
import { FormikProps } from "formik"
import { useRef, useState } from "react"
import { useApiMutation } from "../../../../../core/api/useApiMutation"
import { SuccessDisplay } from "../../../../../core/api/errorTypes"
import { MERCHANT_ADMIN_ROUTE, MERCHANT_NEWS_ROUTE } from "../../../../../constants/routes"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../shared/components/links/StandardBreadcrumbs"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import { MerchantAdminNewsQuery, createMerchantAdminNews } from "../merchantAdminNewsApi"
import { CreateOrEditArticleForm } from "../components/CreateOrEditArticleForm"
import { CreateOrEditArticleFormValues, MerchantArticleStatus } from "../merchantNewsItemType"
import { useMerchant } from "../../../../merchants/merchantHooks"
import { CreateAndPublishSplitButton } from "../components/CreateAndPublishSplitButton"

export function CreateNews() {
    const { merchantId } = useMerchant()
    const navigate = useNavigate()
    const formRef = useRef<FormikProps<CreateOrEditArticleFormValues>>(null)

    const [status, setStatus] = useState<MerchantArticleStatus>(MerchantArticleStatus.DRAFT)

    const handleSaveClick = () => {
        formRef.current?.submitForm()
    }

    const { mutateAsync: callCreateArticle } = useApiMutation(createMerchantAdminNews, {
        successDisplay: SuccessDisplay.SNACKBAR,
        async onSuccess(_, __, context) {
            await context.queryClient.invalidateQueries({ queryKey: [MerchantAdminNewsQuery.LIST] })
            navigate(MERCHANT_NEWS_ROUTE)
        },
    })

    return (
        <>
            <LocalizedStrict id="create-news-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.MERCHANT_NEWS_CREATE}
                    title="Create Article"
                    rightElement={
                        <CreateAndPublishSplitButton
                            status={MerchantArticleStatus.DRAFT}
                            setStatus={setStatus}
                            handleClick={handleSaveClick}
                        />
                    }
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="merchant-nav-item-home">
                            <BreadcrumbLink to={MERCHANT_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-nav-item-merchant-news">
                            <BreadcrumbLink to={MERCHANT_NEWS_ROUTE}>News</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="nav-item-create-news-header">
                            <Breadcrumb>Create News</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>
            <CreateOrEditArticleForm
                ref={formRef}
                onSubmit={(data) => callCreateArticle({ article: { ...data, status }, merchantId: merchantId })}
            />
        </>
    )
}
